<template>
    <div class="row">
        <div class="col-lg-6 mb-1">
            <label class="form-label">Borç/Alacak</label>
            <v-select-list :options="baTypes" label="name" placeholder="Borç/Alacak" v-model="baType"></v-select-list>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Proje Kodu</label>
            <v-select-list :options="projectCodes" label="name" placeholder="Proje Kodu" v-model="projectCode"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yaka</label>
            <v-select-list :options="collarStatuses" label="Name" placeholder="Yaka" v-model="collarStatus"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Muhasebe Hesap Adı</label>
            <v-select-list :options="muhasebePlans" label="Name" placeholder="Muhasebe Hesap Adı" v-model="muhasebePlan"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Muhasebe Hesap Kodu</label>
            <input class="form-control" v-model="value.NetsisAccountCode" placeholder="Muhasebe Hesap Kodu"/>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            baTypes:[
                {name:'Borç',value:'B'},
                {name:'Alacak',value:'A'},
            ],
            projectCodes:[
                {name:'G',value:'G'},
                {name:'R',value:'R'},
            ],
            collarStatuses:[],
            muhasebePlans:[]
        }
    },
    mounted(){
        this.getCollarStatuses()
        this.getMuhasabePlanList()
    },
    methods:{
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        getMuhasabePlanList(){
            SystemDataApi.MuhasabePlani().then(res=>{
                this.muhasebePlans = res.data.Data
            })
        },
    },
    computed:{
        baType:{
            get:function(){
                return this.baTypes.find(b=>b.value==this.value.BAType)
            },
            set:function(value){
                this.value.BAType = value?.value || null
            }
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(b=>b.value==this.value.G_R)
            },
            set:function(value){
                this.value.G_R = value?.value || null
            }
        },
        collarStatus:{
            get:function(){
                return this.collarStatuses.find(s=>s.Id == this.value.CollarStatusId)
            },
            set:function(value){
                this.value.CollarStatusId = value?.Id || null
            }
        },
        muhasebePlan:{
            get:function(){
                return this.muhasebePlans.find(s=>s.Value==this.value.NetsisAccountName)
            },
            set:function(value){
                this.value.NetsisAccountName = value?.Value != null ? value.Value : null
            }
        }
    }
}
</script>